import { InjectionToken } from "@angular/core";

export interface EnvironmentConfig {
  production: boolean,
  apiBaseUrl: string,
  passportHelpServiceUrl: string,
  helpServiceUrl: string,
  redirectFeedback: boolean,
  subscriberServiceUrl: string,
  imagesUrl: string,
  authSettings:{
    authority: string,
    redirectUrl: string,
    postLogoutRedirectUri: string,
    clientId: string,
    scope: string,
    responseType: string,
    silentRenew: boolean,
    useRefreshToken: boolean,
    renewTimeBeforeTokenExpiresInSeconds: number,
    logLevel: number,
    customParamsRefreshTokenRequest:{
      scope: string
    },
    customParamsAuthRequest:{
      acr_values: string,
    }
  }
}

export const ENV_CONFIG = new InjectionToken<EnvironmentConfig>('EnvironmentConfig');
